export default __webpack_public_path__ + "assets/img/mylearning.da17b41f3967e937f620f2c60b1f1884.png";